import React, { FC, useEffect, useState } from 'react'
import { Flex, Text } from '@chakra-ui/layout';
import { motion } from 'framer-motion';
import mtmLandingGraphic from "../assets/images/mtmLogoLg.png";
import {ReactComponent as PointerIcon} from "../assets/images/pointerIcon.svg";
import { useStore } from '../store';
import {RedwoodPalette as colors} from "../data/constants";

const MtmLanding: FC = () => {
  const { width, height } = useStore((state) => state.windowDimensions)
  const [scale, setScale] = useState(1)

  useEffect(() => {
    if(width && height) {
      setScale(height <= 1440 && width <= 1680 ? 0.7 : 1)
    }

  }, [height, width])

  return (
    <MotionFlex
      maxWidth="750px"
      margin="0 auto"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      transform={`scale(${scale})`}
    >
      <MotionFlex>
        <img src={mtmLandingGraphic} alt="Moments that Matter" className={"landing-page-logo"}/>
      </MotionFlex>
      <MotionFlex
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        maxW="498px"
        transform="translateY(-20%)"
        style={{ gap: '16px' }}
      >
        <PointerIcon width="60px"/>
        <Text as="h3" fontSize="30px" color={colors.neutralGrey190}>Tap to start!</Text>
        <Text as="p" fontSize="17px" color={colors.neutralGrey190} align="center" lineHeight="29px">Welcome to the <strong>Moments That Matter</strong> web experience. We have tools that empower our partners to create meaningful communications at every key customer interaction. Here we have collected these stories to share with you.</Text>
      </MotionFlex>
    </MotionFlex>
  )
}

const MotionFlex = motion(Flex);

export { MtmLanding }
